export default {
  root: {
    //borderLeft: '1px solid #CCCCCC',
    //borderRight: '1px solid #CCCCCC'
  }
};
